// 城市合伙人

export const userchildren = [
  {
    path: '/partner/info',
    name: 'partnerInfo',
    component: () => import('@/page/partner/info'),
    meta: {
      title: '我的信息'
    }
  }
]
const partnerRouter = [
  {
    // 登录页面
    path: '/partner',
    name: 'partner',
    meta: {
      authc: true
    },
    component: () => import('@/page/partner/login')
  },
  {
    // 首页
    path: '/partnerIndex',
    name: 'partnerIndex',
    redirect: '/partner/info',
    component: () => import('@/page/partner/index'),
    children: userchildren
  }
]

export default partnerRouter



// WEBPACK FOOTER //
// ./src/router/modules/partner.js